import {defineSlotRecipe} from '@chakra-ui/react3'

export default defineSlotRecipe({
    slots: ['badge'],
    base: {
        badge: {
            whiteSpace: 'nowrap',
            borderRadius: 'xs',
            paddingX: 'spacing-8',
            paddingY: 'spacing-2',
            textStyle: 'body.xsmall',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },

    variants: {
        variant: {
            deal: {
                badge: {
                    backgroundColor: 'background.actions.secondary', // black
                    color: 'text.primary-inverted'
                }
            },
            new: {
                badge: {
                    backgroundColor: 'secondary.cream', // cream
                    color: 'text.on-media.primary'
                }
            },
            productPromo: {
                badge: {
                    backgroundColor: 'secondary.malva', // malva
                    color: 'text.on-media.primary'
                }
            },
            promotions: {
                badge: {
                    backgroundColor: 'secondary.terracotta', // terracotta
                    color: 'text.on-media.primary'
                }
            }
        }
    }
})
